import { createSelector } from 'reselect';
import {
  getSelectedEventProfitBoostItemsUtil,
  getSelectedProfitBoostItemUtil
} from 'utils/betslip/profitBoostHelpers';
import { getSelectorRoot } from 'utils/selectors';
import { GENERAL_FIELD_KEY } from 'newelements/_Betslip/utils/constants/shared';
import { getUser } from 'store/selectors/user-data';

const getBetSlip = getSelectorRoot('betSlip');

const getProfitBoost = getBetSlip('profitBoost');
const getProfitBoostAdvanced = getBetSlip('profitBoostAdvanced');

// @Todo need to update profit Boost selector after changing state

const getProfitBoost_ = getBetSlip('_profitBoost');

const getIsProfitBoostAvailable = createSelector(
  [getUser, getProfitBoost_],
  ({ has_free_bets }, profitBoost) => {
    return (
      has_free_bets &&
      !!(
        profitBoost?.items?.length ||
        Object.values(profitBoost.singleProfitBoostItems).length
      )
    );
  }
);

const getSelectedEventProfitBoostItems = createSelector(
  [getProfitBoost_],
  getSelectedEventProfitBoostItemsUtil
);

const getSelectedProfitBoostItem = createSelector(
  [getProfitBoost_, getSelectedEventProfitBoostItems],
  getSelectedProfitBoostItemUtil
);

const checkIsProfitBoostAvailable = (eventId: string | number) =>
  createSelector(
    [getIsProfitBoostAvailable, getProfitBoost_],
    (isAvailable, { singleProfitBoostItems, items }) => {
      if (!isAvailable) {
        return false;
      }

      if (eventId === GENERAL_FIELD_KEY) {
        return !!items.length;
      }

      return !!singleProfitBoostItems[eventId]?.length;
    }
  );

const getIsEventSelectedOnProfitBoost = (eventId?: string | number) =>
  createSelector(
    [getProfitBoost_],
    ({ profitBoostSelectedEventId }) =>
      !!(profitBoostSelectedEventId && profitBoostSelectedEventId === eventId)
  );

const getSelectedProfitBoostItemByEventId = (
  eventId: string | number | undefined
) =>
  createSelector(
    [getProfitBoost_, getSelectedProfitBoostItem],
    ({ profitBoostSelectedEventId }, selectedProfitBoostItem) => {
      if (profitBoostSelectedEventId !== eventId) {
        return null;
      }

      return selectedProfitBoostItem;
    }
  );

export {
  getProfitBoost,
  getProfitBoostAdvanced,
  getIsProfitBoostAvailable,
  getSelectedProfitBoostItem,
  checkIsProfitBoostAvailable,
  getIsEventSelectedOnProfitBoost,
  getSelectedEventProfitBoostItems,
  getSelectedProfitBoostItemByEventId,
  getProfitBoost_
};
